import React from "react";
import { ReactComponent as SearchIcon } from "@assets/Icons/IconsSearch.svg";

export interface EmptyStateViewProps {
	/** Main title (e.g. "You have no Connectors yet") */
	title: string;
	/** Description paragraph below the title */
	description: string;
	/** Optional custom icon. Default: search icon */
	icon?: React.ReactNode;
	/** Optional class for the container */
	className?: string;
}

const defaultIcon = (
	<SearchIcon className="h-10 w-10 text-semantic-text-secondary" />
);

export const EmptyStateView: React.FC<EmptyStateViewProps> = ({
	title,
	description,
	icon = defaultIcon,
	className = "",
}) => {
	return (
		<div
			className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className}`}
		>
			<div className="bg-semantic-bg-secondary inline-flex items-center justify-center border border-semantic-border-primary rounded-md p-3">
				{icon}
			</div>
			<h3 className="text-lg font-bold text-semantic-text-primary mt-4">
				{title}
			</h3>
			<p className="text-sm text-semantic-text-secondary mt-2 max-w-md">
				{description}
			</p>
		</div>
	);
};

export default EmptyStateView;
